import { render, staticRenderFns } from "./Pro.vue?vue&type=template&id=173120c3&scoped=true"
import script from "./Pro.vue?vue&type=script&lang=js"
export * from "./Pro.vue?vue&type=script&lang=js"
import style0 from "./Pro.vue?vue&type=style&index=0&id=173120c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173120c3",
  null
  
)

export default component.exports